import { createContext } from 'react';

const SearchReqContext = createContext(null);

export default SearchReqContext;